import { useMutation } from '@tanstack/react-query'
import { convertColumbiaTimesheetToVndlyUpload } from 'api/admin/vndly/convertColumbiaTimesheetToVndlyUpload'

export const useConvertColumbiaTimesheetToVndlyUploadMutation = () =>
  useMutation({
    mutationFn: convertColumbiaTimesheetToVndlyUpload,
  })
